import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPeopleEdit = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12.5 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM11.5 12a1 1 0 0 1 0 2c-4.443 0-8 3.162-8 7a1 1 0 0 1-2 0c0-4.999 4.502-9 10-9ZM18.293 13.793l-5 5A1 1 0 0 0 13 19.5v2a1 1 0 0 0 1 1h2a1 1 0 0 0 .707-.293l5-5a1 1 0 0 0 0-1.414l-2-2a1 1 0 0 0-1.414 0ZM19 15.915l.585.585-4.001 4H15v-.586l4-3.999Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPeopleEdit)
const Memo = memo(ForwardRef)
export default Memo
